import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_90: FaireProductEntity = {
  token: "legacy_prod_abbott-90",
  type: "product",
  name: "Small Velvet Pouch with 3D Bee, Black 4×6 L",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d11697f263e0d3e10ecc3a8d91e82f2c3577dc3f4fdc85b0f1f2e482c5ee9166.jpeg",
  priceDollars: 10,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_womens-accessories"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
